import { localisateurAffiche } from '../domaine/citations';
// CX6 : lecture des calculs du moteur, sans calcul de risque dans le navigateur.
import type { FournisseurCritique } from '../api/types';
import { eurosLong } from '../domaine/format';

function pertes(p: [number, number] | null) {
  return p ? `${eurosLong(p[0])} à ${eurosLong(p[1])}` : 'Non déterminées ; accès ou comptes à confirmer';
}

export function Fournisseurs({ fournisseurs, nom }: {
  fournisseurs: FournisseurCritique[];
  nom: (id: string) => string;
}) {
  return <section className="panneau" aria-labelledby="t-fournisseurs">
    <h2 id="t-fournisseurs">Fournisseurs critiques</h2>
    <p>Hypothèse de compromission du fournisseur : ce qu’elle arrêterait chez vous. Aucun fournisseur n’est
      déclaré compromis et aucune note externe n’est attribuée.</p>
    <p>Pertes potentielles estimées par sinistre, conditionnelles aux hypothèses retenues (calibration provisoire,
      non validée par un actuaire). Classement par valeur haute ; ces scénarios ne s’ajoutent pas au total annuel.</p>
    {!fournisseurs.length && <p>Aucun fournisseur renseigné ; accès à confirmer.</p>}
    {fournisseurs.map(f => <details key={f.id}>
      <summary>{f.nom} — {pertes(f.scenario.perte)}</summary>
      <p>{f.limite}</p>
      {f.scenario.etat === 'acces_a_confirmer' && <p><strong>Accès à confirmer</strong> ; aucune absence d’accès supposée.</p>}
      <p>Portes d’entrée connues : {f.scenario.entrees.map(nom).join(', ') || 'à confirmer'}.</p>
      <p>Processus qui seraient arrêtés : {f.scenario.processus_arretes.map(nom).join(', ') || 'non déterminés'}.</p>
      <h3>Accès et provenance</h3>
      {f.acces.map(a => <div key={a.id}>
        <p>{a.label} — {a.enabled ? 'accès déclaré actif' : 'accès déclaré désactivé'}</p>
        {a.provenance.citations.length ? a.provenance.citations.map((c, i) =>
          <blockquote key={i}>« {c.excerpt} » — {c.source_id}, {localisateurAffiche(c.locator)} (citation à vérifier)</blockquote>)
          : <p>Provenance documentaire à compléter.</p>}
      </div>)}
      <h3>Données confiées</h3>
      <p>{f.donnees_confiees.map(d => d.label).join(', ') || 'À confirmer ; aucune absence de données confiées supposée.'}</p>
      <h3>Questionnaires et preuves reçus</h3>
      {f.pieces.length ? <ul>{f.pieces.map((p, i) => <li key={i}>{p.kind} — {p.source_id} :
        {p.reference_connue ? ' référence connue dans les pièces' : ' pièce à retrouver'}.
        La présence d’une pièce ne prouve pas son contenu.</li>)}</ul> : <p>Aucune pièce reçue référencée.</p>}
      <h3>Mesures proposées, à valider par l’entreprise</h3>
      {f.mesures.map(v => <details key={v.id}>
        <summary>{v.libelle} — {eurosLong(v.cout.total)} sur {v.cout.horizon} ans</summary>
        <p>{v.detail} Coût indicatif du moteur, à confirmer par devis.</p>
        <p>Après simulation : {pertes(v.apres.perte)} par sinistre.</p>
        <p>Processus qui seraient arrêtés après simulation : {v.apres.processus_arretes.map(nom).join(', ') || 'non déterminés'}.</p>
        {!!v.continuite_a_verifier.length && <p>Continuité à vérifier avant toute coupure :
          {' '}{v.continuite_a_verifier.map(nom).join(', ')}. Les accès inconnus restent à confirmer.</p>}
        <p>Simulation seulement ; aucune écriture dans les outils du client.</p>
      </details>)}
    </details>)}
  </section>;
}
